import { MailCheck, Users } from "lucide-react";

function Stat({ icon: Icon, label, value, color, tid }) {
  return (
    <div className="glass rounded-2xl p-5" data-testid={tid}>
      <Icon className={"w-5 h-5 mb-2 " + color} />
      <div className="font-mono text-[10px] uppercase tracking-widest text-white/60">{label}</div>
      <div className="font-display text-3xl font-bold mt-1">{value}</div>
    </div>
  );
}

export default function AdminWaitlistStats({ total, invited }) {
  const waiting = Math.max(0, total - invited);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <Stat tid="stat-total"   icon={Users}     label="Total signups" value={total === null ? "—" : total} color="text-neon-cyan" />
      <Stat tid="stat-invited" icon={MailCheck} label="Invited"       value={invited}                     color="text-neon-lime" />
      <Stat tid="stat-waiting" icon={Users}     label="Waiting"       value={waiting}                     color="text-neon-pink" />
    </div>
  );
}
